// extracted by mini-css-extract-plugin
export default {"emote":"_3OyoW","not-official":"_3WMMe","notOfficial":"_3WMMe","title":"_1GSvG","emote-pixel":"_1_Tci","emotePixel":"_1_Tci"};